export const customPluginAttrPrefix = 'data-tmce-plugin';
export const customPluginNameAttr = `${customPluginAttrPrefix}-name`;
